import React, { useEffect } from 'react';
import './TermsModal.css';

const TermsModal = ({ html, onClose }) => {
  // Lock body scroll while open, matching the app's other modals.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const hasContent = !!(html && html.trim());

  return (
    <div
      className="terms-backdrop"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-label="Terms and conditions"
    >
      <div className="terms-sheet">
        <div className="terms-header">
          <h3 className="terms-title">Terms &amp; Conditions</h3>
          <button className="terms-close-btn" onClick={onClose} aria-label="Close">×</button>
        </div>
        {hasContent ? (
          <div className="terms-content" dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <p className="terms-empty">No terms and conditions have been provided.</p>
        )}
      </div>
    </div>
  );
};

export default TermsModal;
